import '../styles/app.css';

const TypeBox = ({children}) => {
    return (
        <div className="typeBox">
            {children}
        </div>
    )
}

export default TypeBox